import React from 'react'
import Spacer from '@berlitz/spacer'
import { H3 } from '@berlitz/globals/lib/components/typography'
import { Row, Col } from 'react-styled-flexboxgrid'
import NavWidget from './NavWidget'
import Button from '@berlitz/button'

import {
  Banner,
  BannerH1,
  FullWidthGrid,
  Headings,
  Inner,
  BackgroundImage,
  TextAlignBlock,
} from './style.js'

const PageBanner = ({
  backgroundImageSrc,
  flipText,
  inverse = true,
  large,
  subtitle,
  title,
  navigationWidgetData,
  showNavWidget,
  disableCta,
  ctaData = {},
}) => {
  return (
    <Banner isLarge={large} data-key="max-page-banner">
      <picture>
        <BackgroundImage
          src={backgroundImageSrc}
          role="presentation"
          data-key="max-page-banner__background"
        />
      </picture>
      <Inner>
        <FullWidthGrid>
          <Row center="xs">
            <Col lg={10} xs={12}>
              <Headings flipText={flipText}>
                <BannerH1
                  inverse={inverse}
                  disableMargin
                  data-key="max-page-banner__title"
                  dangerouslySetInnerHTML={{ __html: title }}
                />
                {subtitle && (
                  <>
                    <Spacer size="xs" breakpoints={{ md: 'md' }} />
                    <H3
                      disableMargin
                      inverse={inverse}
                      as="p"
                      data-key="max-page-banner__subtitle"
                      dangerouslySetInnerHTML={{ __html: subtitle }}
                    />
                  </>
                )}
                {showNavWidget && navigationWidgetData.length && (
                  <Spacer size="xs" breakpoints={{ md: 'md' }}>
                    <NavWidget data={navigationWidgetData} />
                  </Spacer>
                )}
                {disableCta ||
                  ((ctaData?.normal_link || ctaData?.one_page_link) &&
                    ctaData?.label && (
                      <TextAlignBlock align="center" data-key="banner-cta">
                        <Button
                          as="a"
                          href={
                            ctaData?.one_page_link
                              ? ctaData?.one_page_link
                              : ctaData?.normal_link.document.url
                          }
                          target={ctaData.isExternal ? '_blank' : '_self'}
                          rel={
                            ctaData.isExternal ? 'noopener noreferrer' : null
                          }
                          inlineBlock
                        >
                          {ctaData.label}
                        </Button>
                      </TextAlignBlock>
                    ))}
              </Headings>
            </Col>
          </Row>
        </FullWidthGrid>
      </Inner>
    </Banner>
  )
}

export default PageBanner
